import get from 'lodash-es/get';

import store from 'app/store';
import {
  changeFieldValue,
  changeFieldValueAndUpdate,
  getFormValue,
  getFormValues,
  getQuestion,
  getSection,
  setQuestionPatchable,
} from 'app/services/businessFunctionHelpers';
import {
  FieldsEnum,
  FormsEnum,
  ModelPathEnum,
  SectionsEnum,
} from 'app/shared/enums';
import { QuestionInterface } from 'app/shared/interfaces/Question.interface';
import { TravelQuotationService } from 'app/services/travelQuotation.service';
import { isEmailValid } from 'app/validators';

const formName = FormsEnum.TravelForm;

export const consents = {
  fillAllRequiredTravelConsents(initialRun: boolean) {
    const value = get(getFormValues(formName), FieldsEnum.ButtonConsentsTravel);
    const section = getSection(SectionsEnum.TravelConsents, formName);

    section.questions
      .map((questionKey: FieldsEnum) => getQuestion(questionKey, formName))
      .forEach((question: QuestionInterface) =>
        changeFieldValueAndUpdate(question.key, value, formName)
      );
  },

  requiredTravelCalculationConsentChange() {
    changeFieldValue(FieldsEnum.ButtonConsentsTravel, false, formName);

    const state = store.getState();
    const { travelQuotation } = state;
    const formEmailAddress = getFormValue(
      FieldsEnum.TravelEmailAddress,
      formName
    );
    const emailValid =
      (formEmailAddress && isEmailValid(formEmailAddress, true)) ||
      formEmailAddress === '';
    const regulationsConsentAccepted = getFormValue(
      FieldsEnum.ConsentRegulations,
      formName
    );

    setQuestionPatchable({
      shouldPatch: regulationsConsentAccepted,
      key: FieldsEnum.TravelEmailAddress,
      formName,
    });

    if (regulationsConsentAccepted && emailValid) {
      TravelQuotationService.update(
        travelQuotation.id,
        ModelPathEnum.EmailAddress,
        formEmailAddress
      );
    } else if (!regulationsConsentAccepted) {
      TravelQuotationService.update(
        travelQuotation.id,
        ModelPathEnum.EmailAddress,
        null
      );
    }
  },

  onTravelInsuranceMarketingConsentChange() {
    changeFieldValue(FieldsEnum.ButtonConsentsTravel, false, formName);
  },
};
